/**
 * 相亲角推送表请求接口
 * @author 王振宇
 * @since 2022-11-18
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_PAGE_LIST: function GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_LIST: function GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/getList',
        method: 'get',
        params: data
      });
    },
    GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_INFO: function GET_ANGLEOFAFFINITYMEMBERPUSHMESAGE_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/info',
        method: 'get',
        params: data
      });
    },
    SAVE_ANGLEOFAFFINITYMEMBERPUSHMESAGE: function SAVE_ANGLEOFAFFINITYMEMBERPUSHMESAGE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_ANGLEOFAFFINITYMEMBERPUSHMESAGE: function UPDATE_ANGLEOFAFFINITYMEMBERPUSHMESAGE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/update',
        method: 'put',
        data: data
      });
    },
    DELETE_ANGLEOFAFFINITYMEMBERPUSHMESAGE: function DELETE_ANGLEOFAFFINITYMEMBERPUSHMESAGE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_ANGLEOFAFFINITYMEMBERPUSHMESAGE: function DELETE_BATCH_ANGLEOFAFFINITYMEMBERPUSHMESAGE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityMemberPushMesage/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});